import { render, staticRenderFns } from "./approvedrequests.vue?vue&type=template&id=50b64529&"
import script from "./approvedrequests.vue?vue&type=script&lang=js&"
export * from "./approvedrequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports